import {
    Box,
    FormControl,
    InputLabel,
    makeStyles,
    Select,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { initIamsmartFieldMap } from "../../redux/action";
import { getFormId, getIamsmartFieldMap } from "../../redux/selector";
import { isNotEmpty, isObjectNotEmpty } from "../../Utils";
import "./CustomSelect.scss";
const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        "& .MuiSelect-select.MuiSelect-select": {
            padding: "6px 0 7px 2px",
            lineHeight: "normal",
            height: "auto",
        },
    },
    root: {
        width: "80%",
        "& .MuiSelect-select.MuiSelect-select": {
            padding: "6px 0 7px 2px",
            lineHeight: "normal",
            height: "auto",
        },
    },
}));

const useLineStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
    },
    root: {
        width: "90%",
    },
}));

export default function CustomSelect({
    control,
    label = "",
    name,
    options,
    required = true,
    showError = true,
    onChange = () => {},
    inputProps = {},
    fullWidth = false,
    toolTip = null,
    needValue = false,
    inlineText = false,
    disabled = false,
    isFixed = false,
    ErrorMsgStyle = {},
    lineController = false,
    filterEmpty = false,
    displayColon = true,
    optgroup = false,
    needHiddenValue = true,
    ...rest
}) {
    const [id, setId] = useState();
    useEffect(() => {
        if (isNotEmpty(inputProps?.name)) {
            setId(inputProps.name);
        }
        if (isNotEmpty(rest?.id)) {
            setId(String(rest.id).split(" ").join("_"));
        }
    }, [inputProps?.name, rest?.id]);
    const restProps = {
        ...rest,
        id,
    };
    const classes = lineController ? useLineStyles() : useStyles();
    const { t, i18n } = useTranslation();
    const formId = useSelector(getFormId());

    // if label present by array, not string
    const handleMultiLabel = (labelList) => {
        return labelList.map((label) => {
            return (
                <>
                    {label}
                    <br />
                </>
            );
        });
    };

    const iasFieldMap = useSelector(getIamsmartFieldMap());

    const dispatch = useDispatch();
    function handle(e) {
        if (isObjectNotEmpty(iasFieldMap) && isObjectNotEmpty(options)) {
            let titleValue = e.value;
            console.log(
                " before change titleValue *****************==========*******",
                titleValue
            );
            console.log(
                " before change iasFieldMap *****************==========*******",
                iasFieldMap
            );
            let titleTag = iasFieldMap?.title?.isChanged;
            console.log(
                " before change titleTag *****************==========*******",
                titleTag
            );
            console.log(
                " before change options *****************==========*******",
                options
            );
            let optionsArray = Object.keys(options);
            console.log(
                " before change optionsArray *****************==========*******",
                optionsArray
            );
            if (
                isNotEmpty(titleValue) &&
                !optionsArray.includes(titleValue) &&
                titleTag === false
            ) {
                iasFieldMap["title"].isChanged = true;
                setTimeout(() => {
                    dispatch(initIamsmartFieldMap(iasFieldMap));
                }, 100);
                console.log(
                    " after change iasFieldMap *****************==========*******",
                    iasFieldMap
                );
            }
        }

        return e.value;
    }

    return (
        <>
            <InputLabel shrink htmlFor={name} className="hidden" id={name}>
                {label}
                {t("common.colon")}
            </InputLabel>
            <Controller
                className={fullWidth ? classes.container : classes.root}
                control={control}
                name={name}
                render={({ field, fieldState: { error } }) => (
                    <FormControl
                        error={isObjectNotEmpty(error)}
                        className={
                            inlineText && fullWidth
                                ? classes.container
                                : classes.root
                        }
                        disabled={disabled}
                    >
                        {isNotEmpty(label) && (
                            <InputLabel shrink>
                                {label}
                                {displayColon && t("common.colon")}
                                {required && (
                                    <Box component="span" className="danger">
                                        *
                                    </Box>
                                )}
                                {isNotEmpty(toolTip) ? toolTip : null}
                            </InputLabel>
                        )}
                        {isFixed && (
                            <InputLabel style={{ opacity: "0" }} shrink>
                                a
                            </InputLabel>
                        )}
                        <Select
                            className={fullWidth ? "" : classes.container}
                            displayEmpty={
                                !filterEmpty && formId === "Form101"
                                    ? false
                                    : true
                            }
                            value={field.value}
                            onChange={(e) => {
                                if (
                                    formId === "Form101" &&
                                    e.target.value === "empty"
                                ) {
                                    field.onChange("");
                                } else {
                                    field.onChange(e.target.value);
                                }
                                onChange(e);
                            }}
                            inputProps={{
                                "aria-labelledby": name,
                                ...inputProps,
                            }}
                            native
                            {...restProps}
                        >
                            {formId === "Form101" || formId === "Form009" ? (
                                <>
                                    <option
                                        value=""
                                        style={{ display: "none" }}
                                    ></option>
                                    <option
                                        value={
                                            formId === "Form009" ? "" : "empty"
                                        }
                                        style={{ fontStyle: "italic" }}
                                    >
                                        {t("Form101.label.noneOption")}
                                    </option>
                                </>
                            ) : (
                                needHiddenValue && (
                                    <option
                                        value=""
                                        style={{ display: "none" }}
                                    ></option>
                                )
                            )}
                            {optgroup
                                ? Object.entries(options).map(
                                      ([key, optionLabel]) => (
                                          <optgroup
                                              label={key}
                                              key={key}
                                              style={{
                                                  padding: "3px 5px",
                                              }}
                                          >
                                              {Object.entries(optionLabel).map(
                                                  ([key2, optionLabel2]) => (
                                                      <option
                                                          value={key2}
                                                          key={key2}
                                                          style={{
                                                              padding:
                                                                  "5px 8px",
                                                              cursor: "pointer",
                                                          }}
                                                      >
                                                          {optionLabel2}
                                                      </option>
                                                  )
                                              )}
                                          </optgroup>
                                      )
                                  )
                                : Object.entries(options).map(
                                      ([key, optionLabel]) => (
                                          <option
                                              className="hoverColor"
                                              key={key}
                                              value={
                                                  needValue ? optionLabel : key
                                              }
                                          >
                                              {optionLabel}
                                          </option>
                                      )
                                  )}
                        </Select>
                        {showError && (
                            <ErrorMsg
                                message={error?.message}
                                style={ErrorMsgStyle}
                            />
                        )}
                    </FormControl>
                )}
            />
        </>
    );
}
